export const BRAND = {
  name: "FLASH Service & Consulting",
  shortName: "FLASH",
  concept: "Il tuo centro servizi, in sede e online.",
  tagline: "Le tue pratiche, il nostro impegno.",
};
